export const ONE_DAY_MS = 86400000
export const ONE_HOUR_MS = 3600000
export const ONE_MINUTE_MS = 60000
export const ONE_SECOND_MS = 1000
